import { ITrendBucketConfig } from "@backend/src/shared/schemas/schemas";

/**
 * NOTE: We use a tiny epsilon to convert "minExclusive" to a practical inclusive min.
 * This is only needed if you model exclusive bounds in the UI-spec.
 */
const EPS = 1e-9;

type ColorSpecLike = {
  id: string;
  range?: {
    minExclusive?: number;
    minInclusive?: number;
    maxInclusive?: number;
  };
};

/**
 * Lager bucketConfig basert på colorSpecs.range.
 * - Returnerer null hvis ingen ranges finnes (altså kategorisk trend).
 * - Returnerer {kind:"ranges"} hvis minst én range finnes.
 */
export function buildBucketConfigFromColorSpecs(
  colorSpecs: ColorSpecLike[] | undefined
): ITrendBucketConfig | null {
  const specs = colorSpecs ?? [];

  const ranged = specs
    .filter(
      (s) =>
        s.range &&
        s.range.maxInclusive != null &&
        (s.range.minInclusive != null || s.range.minExclusive != null)
    )
    .map((s) => {
      const r = s.range!;
      const min = r.minInclusive != null ? r.minInclusive : (r.minExclusive as number) + EPS;

      const max = r.maxInclusive as number;

      return { id: s.id, min, max };
    });

  if (ranged.length === 0) return null;

  // Sort to make deterministic & nice for backend $cond-chain
  ranged.sort((a, b) => a.min - b.min);

  return {
    kind: "ranges",
    ranges: ranged,
  };
}
